module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Title","titleShort":"Title","author":"Author","authorShort":"Author","cover":"Article cover","cancel":"Cancel","publish":"Publish","placeholderEditor":"Insert text here","placeholderEditorShort":"Text","goBack":"Go back","articleCover":"Add cover","articleCoverChange":"Change cover","preview":"Preview","notFound":"Failed to get article","removePublication":"Unpublish"}}')
  delete Component.options._Ctor
}
